import { ConcreteEncodable } from "./ConcreteEncodable";

import { ManualNettingBulkEventImplEncoder } from "../../encoder/ManualNettingBulkEventImplEncoder";

import * as CubiqTS from "../../index";
import { ManualNettingBulkEvent } from "../ManualNettingBulkEvent";

export class ManualNettingBulkEventImpl
  extends ConcreteEncodable
  implements ManualNettingBulkEvent
{
  public static enType: string = "com.bcdfx.model.event.ManualNettingBulkEventImpl";

  /*FID=1*/
  public nettingPairs: Array<CubiqTS.NettingPair> | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ManualNettingBulkEventImplEncoder.Instance;
    this.setEncodableType(ManualNettingBulkEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ManualNettingBulkEventImpl[" +
      "nettingPairs=" +
      this.nettingPairs +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
